<template>
  <div class="user-qr">
    <MyQrCard :userInfo="userInfo" :publish="true" v-if="!loadingUserInfo"/>
  </div>
</template>

<script>
import MyQrCard from '@/components/MyQrCard.vue'

export default {
  name: 'UserQr',
  components: {
    MyQrCard
  },
  data () {
    return {
      loadingUserInfo: true,
      userInfo: null,
      lang: 'th'
    }
  },
  mounted () {
    var self = this
    if ('lang' in self.$route.query) {
      self.lang = self.$route.query.lang
    }
    self.$i18n.locale = self.lang
    self.getUserInfo()
  },
  methods: {
    getUserInfo () {
      var self = this
      self.pp.getUserInformation(
        self.$route.params.id,
        undefined,
        (result) => {
          if (result.status.code === 200) {
            self.userInfo = result.data
            self.loadingUserInfo = false
          } else if (result.status.code === 401) {
            console.log(result.status.text)
          } else if (result.status.code === 403) {
            console.log(result.status.text)
          } else if (result.status.code === 404) {
            console.log(result.status.text)
          } else {
            console.log(result.status.text)
          }
        }
      )
    }
  }
}
</script>

<style scoped>
  .user-qr {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/UserQr.vue